import { Box, useTheme } from '@mui/material';
import { useState } from 'react';
import { ReactComponent as CalendarDisabledIcon } from '../../../../assets/icons/calendar-disabled.svg';
import { Typography } from '../../../../components/Typography/Typography';
import TooltipComponent from '../../../../components/TooltipComponent/TooltipComponent';

interface Props {
  text: string;
  style?: React.CSSProperties;
  holidayName?: string;
}

export const LightDateHeaderCell = ({ text, style, holidayName }: Props) => {
  const { colors } = useTheme();
  const [showToolip, setShowToolip] = useState(false);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '5px',
        alignItems: 'center',
      }}
    >
      <Typography
        variant='subtitle1'
        color={colors.text.main}
        style={{ letterSpacing: '0.25px', ...style }}
      >
        {text}
      </Typography>
      {!!holidayName && (
        <Box marginTop='4px'>
          <TooltipComponent
            open={showToolip}
            onClose={() => setShowToolip(false)}
            onOpen={() => setShowToolip(true)}
            placement='top'
            disablePortal={false}
            content={
              <Typography variant='body' color={colors.text.main}>
                {holidayName}
              </Typography>
            }
          >
            <CalendarDisabledIcon
              onMouseEnter={() => setShowToolip(true)}
              onMouseLeave={() => setShowToolip(false)}
            />
          </TooltipComponent>
        </Box>
      )}
    </Box>
  );
};
